import img5021732494863 from "./50217324948.jpg";
import img5021732531179 from "./5021732531179.jpg";
import img5021732531186 from "./5021732531186B.jpg";
import img0093624837893 from "./0093624837893.jpg";
import img0093624837893B from "./0093624837893B.jpg";
import img4029759205333 from "./4029759205333.jpg";
import img5021732587084 from "./5021732587084.jpg";
import img5021732587084B from "./5021732587084B.jpg";
import img0603497819119 from "./0603497819119.jpg";
import img0603497819119B from "./0603497819119B.jpg";
import img0603497818488 from "./0603497818488.jpg";
import img0603497818488B from "./0603497818488B.jpg";
import img0603497819751 from "./060349781975.jpg";
import img0603497819751B from "./0603497819751B.jpg";
import img0081227812058 from "./0081227812058.jpg";
import img0081227812058B from "./0081227812058B.jpg";
import img5054197638831 from "./5054197638831.jpg";
import img5054197638831B from "./5054197638831B.jpg";
import img0603497819263 from "./0603497819263.jpg";
import img0603497819263B from "./0603497819263B.jpg";
import img0075678603020 from "./0075678603020.jpg";
import img0075678603020B from "./0075678603020B.jpg";
import img5021732545046 from "./5021732545046.jpg";
import img5021732545046B from "./5021732545046B.jpg";
import img0603497818686 from "./0603497818686.jpg";
import img0603497818686B from "./0603497818686B.jpg";
import img0603497818938 from "./0603497818938.jpg";
import img0603497818938B from "./0603497818938B.jpg";
import img0081227811532 from "./0081227811532.jpg";
import img0081227811532B from "./0081227811532B.jpg";
import img0603497818945 from "./0603497818945.jpg";
import img0603497818945B from "./0603497818945B.jpg";
import img0081227812102 from "./0081227812102.jpg";
import img0603497818952 from "./0603497818952B.jpg";
import img0603497818952B from "./0603497818952B.jpg";
import img0603497816378 from "./0603497816378.jpg";
import img0603497816378B from "./0603497816378B.jpg";
import img0603497818846 from "./0603497818846.jpg";
import img0603497818846B from "./0603497818846B.jpg";
import img0603497817276 from "./0603497817276.jpg";
import img0603497817276B from "./0603497817276B.jpg";
import img0603497818921 from "./0603497818921.jpg";
import img0603497818921B from "./0603497818921B.jpg";
import img5021732531223 from "./5021732531223.jpg";
import img5021732531186B from "./5021732531186B.jpg";
import img5021732531223B from "./5021732531223B.jpg";
import img0810075114867 from "./810075114867.jpg";
import img0081227812096 from "./0081227812096.jpg";
import img0081227812096B from "./0081227812096B.jpg";
import img0603497818969 from "./0603497818969.jpg";
import img0603497818969B from "./0603497818969B.jpg";
import img0075678601699 from "./0075678601699.jpg";
import img0075678601699B from "./0075678601699B.jpg";
import img0603497819140 from "./0603497819140.jpg";
import img0603497819140B from "./0603497819140B.jpg";
import wa2 from "./wa2.jpg";
import wa5 from "./wa5.jpg";
import wa7 from "./wa7.jpg";
import wa8 from "./wa8.jpg";
import wa9 from "./wa9.jpg";

const records = [
  // Autres
  {
    artist: "Blur",
    title: "The Magic Whip",
    format: "LP - Zoetrope Picture Vinyl",
    description:
      'Réédition 10ème anniversaire vinyle zoetrope du 8ème album de Blur. Inclus les hits "Ghost Ship", "Go Out", "Lonesome Street" et "Ong Ong".',
    ref: [wa7],
  },
  {
    artist: "David Bowie",
    title: "Ready, Set, Go !",
    format: "2LP - 180gr. & CD - Softpack",
    description:
      "Le 8 septembre 2003, David Bowie est entré dans l'histoire en organisant le plus grand événement musical en direct et interactif par satellite que le monde ait jamais connu. Ce concert exceptionnel a été retransmis par satellite depuis les Riverside Studios de Londres, simultanément à 50 000 fans dans 86 cinémas de 26 pays de la planète, de Hong Kong à Helsinki, et a enthousiasmé les fans avec une performance spectaculaire et inédite de son tout nouvel album, Reality. À l'occasion du Record Store Day 2025, le concert sera édité pour la première fois en vinyle 180 gr., avec une réplique de l'affiche de l'événement. Disponible également en version CD.",
    ref: [img5021732531179, img5021732531186B],
  },
  // {
  //   artist: "David Bowie",
  //   title: "Ready, Set, Go !",
  //   format: "CD - Softpack",
  //   description:
  //     "Le 8 septembre 2003, David Bowie est entré dans l'histoire en organisant le plus grand événement musical en direct et interactif par satellite que le monde ait jamais connu. Ce concert exceptionnel a été retransmis par satellite depuis les Riverside Studios de Londres, simultanément à 50 000 fans dans 86 cinémas de 26 pays de la planète, de Hong Kong à Helsinki, et a enthousiasmé les fans avec une performance spectaculaire et inédite de son tout nouvel album, Reality. À l'occasion du Record Store Day 2025, le concert sera édité pour la première fois en vinyle 180 gr., avec une réplique de l'affiche de l'événement.",
  //   ref: [img5021732531186],
  // },
  {
    artist: "Dead Sara",
    title: "Ain't it Tragic",
    format: "LP - Lemonade Vinyl",
    description:
      'Voici le 3ème album de Dead Sara sorti en 2021 disponible pour la première fois en vinyle pour le Record Store Day. Cet album, porté par les singles "Heroes" et "Hands up", marque la renaissance du groupe composé de Siouxsie Medley à la guitare, Sean Friday à la batterie et Emily Armstrong au chant qui officie aujourd\'hui dans le groupe Linkin Park.',
    ref: [img0093624837893, img0093624837893B],
  },
  {
    artist: "Deep Purple",
    title: "Extras: The Now What?! B-Sides And Bonus Songs",
    format: "LP Violet",
    description:
      "La compilation de B-sides “Extras: The Now What?! B-Sides And Bonus Songs” de Deep Purple extrait de l’ère Now What?! (2013) sera disponible pour la première fois en vinyle ! Disponible en Vinyle Violet 180g de haute-qualité et en exclusivité pour le Disquaire Day 2025, un must-have pour tous les fans et collectionneurs des légendes Deep Purple !exclusive for Record Store Day 2025 !",
    ref: [wa8],
  },
  {
    artist: "Dusty Springfield",
    title: "Reputation",
    format: "LP - Pink Vinyl",
    description:
      "Réédition remasterisée vinyle de couleur du 14ème album de Dusty Springfield sorti en 1990 après une pause discographique d'une dizaine d'années. Album produit par les Pet Shop Boys et Julian Mandelsohn.",
    ref: [img5021732587084, img5021732587084B],
  },
  {
    artist: "Fleetwood Mac",
    title: "Fleetwood Mac",
    format: "LP - Picture Disc",
    description:
      'Réédition vinyle picture de l\'album éponyme de Fleetwood Mac pour fêter son 50ème anniversaire. Inclus les singles "Landslide", "Say You Love Me" & "Rhiannon".',
    ref: [wa9, img0603497819119B],
  },
  {
    artist: "Grateful Dead",
    title: "On a Back Porch Vol. 1",
    format: "LP - 180gr.",
    description:
      'Compilation de titres live enregistrés en 1969, 1973, 1977, 1989 et 1991. Le tracklisting pioche dans toutes les périodes du groupe. On y retrouve les classiques "Eyes Of The World" et "Here Comes Sunshine" et les raretés "Easy Wind" et "Big Railroad Blues". Masterisé par David Glasser.',
    ref: [img0603497818488, img0603497818488B],
  },
  {
    artist: "Grateful Dead",
    title: "Beacon Theatre, New York, NY 6/14/76",
    format: "5LP - 180gr.",
    description:
      "Le concert enregistré au Beacon Theatre de New York le 14 juin 1976 enfin disponible en vinyle en version intégrale ! Un concert d'anthologie !",
    ref: [wa5, img0603497819751B],
  },
  {
    artist: "Jet",
    title: "Get Born Rarities",
    format: "LP",
    description:
      "Compilation de raretés : 11 faces B, demos, sessions radio, versions live et alternatives.",
    ref: [img0081227812058, img0081227812058B],
  },
  {
    artist: "Jethro Tull",
    title: "Songs from the Vault : 1975-1978",
    format: "2LP",
    description:
      "Compilations de raretés enregistrées lors des sessions d'enregistrement des albums Minstrel In The Gallery, Too Old To Rock 'n' Roll : Too Young To Die !, Songs From The Wood et Heavy Horses.",
    ref: [img5054197638831, img5054197638831B],
  },
  {
    artist: "Joni Mitchell",
    title: "Live 1976",
    format: "3LP",
    description:
      "Compilation de titres live enregistrés sur la tounée américaine de 1976.",
    ref: [wa2, img0603497819263B],
  },
  {
    artist: "Kaleo",
    title: "All the Pretty Girls EP",
    format: "LP - Raspberry Marble Vinyl",
    description:
      'EP 10ème anniversaire du single "All The Pretty Girls" avec "All The Pretty Girls", "Way Down We Go" et la reprise "Bang Bang (My Baby Shot Me Down)" enregistrée en live au SiriusXM Studios.',
    ref: [img0075678603020, img0075678603020B],
  },
  {
    artist: "Liam Gallagher",
    title: "Acoustic Sessions",
    format: "LP - Silver & Blue Vinyl",
    description:
      'Version vinyle du EP acoustique sorti en digital en 2020. On y retrouve des chansons de son album Why me, Why not ainsi que des standards d\'Oasis "Cast No Shadow", "Sad Song" & "Stand By Me".',
    ref: [img5021732545046, img5021732545046B],
  },
  {
    artist: "Morphine",
    title: "Bootleg Detroit",
    format: "LP - Milky Clear Vinyl",
    description:
      "Morphine's Bootleg Detroit, concert enregistré au St. Andrew’s Hall en 1994 sur la tournée Cure for Pain tour, sera disponible en vinyle pour la première fois pour le Record Store Day.",
    ref: [img0603497818686, img0603497818686B],
  },
  {
    artist: "Neurotic Outsiders",
    title: "Neurotic Outsiders",
    format: "2LP",
    description:
      "Réédition vinyle du 1er album de Neurotic Outsiders, supergroupe formé en 1995 avec Steve Jones des The Sex Pistols, John Taylor de Duran Duran et Duff McKagan et Matt Sorum de Guns & Roses. Inclus des titres bonus.",
    ref: [img0603497818938, img0603497818938B],
  },
  {
    artist: "Prince",
    title: "Live at Glam Slam",
    format: "3LP - Yellow Vinyl",
    description:
      "Sorti à l'origine dans le coffret Deluxe de la réédition de l'album Diamonds and Pearls en 2022, le live à Glam Slam sera disponible en vinyle de couleur pour le Record Store Day. Le concert a été enregistré le 11 janvier 1992 à Minneapolis avant le début de la tournée Diamonds and Pearls.",
    ref: [img0081227811532, img0081227811532B],
  },
  {
    artist: "Ramones",
    title: "Loco Live",
    format: "2LP - Blue and Red vinyl",
    description:
      "Réédition vinyle de couleur du 2ème album live des Ramones sorti en 1991. Remaster 2025.",
    ref: [img0603497818945, img0603497818945B],
  },
  {
    artist: "Robert Hunter",
    title: "Tiger Rose Rarities",
    format: "LP",
    description:
      "Réédition 50ème anniversaire du 2ème album de Robert Hunter parolier des Grateful Dead. Inclus des versions alternatives et un nouvel artwork.",
    ref: [img0081227812102],
  },
  {
    artist: "Starship",
    title: "We Built this City",
    format: "MX45T - Picture Disc",
    description:
      'Réédition vinyle picture du hit single "We Built this City". Inclus "We Built this City" en version originale et Special Club Mix ainsi qu\'une version instrumentale du titre "Private Room".',
    ref: [img0603497818952, img0603497818952B],
  },
  {
    artist: "Stone Temple Pilots",
    title: "Live in New Haven 1994",
    format: "2LP - Purple Vinyl",
    description:
      'Concert enregistré à New Haven le 23 août 1994 un mois après la sortie de l\'album Purple. Inclus les hits "Vasoline", "Plush" et "Interstate Love Song".',
    ref: [img0603497816378, img0603497816378B],
  },
  {
    artist: "Talking Heads",
    title: "Live on Tour",
    format: "2LP",
    description:
      "Live On Tour a été enregistré à l'Agora de Cleveland le 18 décembre 1978 sur la tournée More Songs About Buildings and Food tour. Le concert, sorti en vinyle Promo en 1979 à l'intention des radios, est enfin disponible officiellement dans une version remasterisée avec un titre bonus.",
    ref: [img0603497818846, img0603497818846B],
  },
  {
    artist: "The Doors",
    title: "Strange Days 1967 – A Work in Progress",
    format: "LP - Blue Vinyl",
    description:
      "Version Work in Progress de l'album Strange Days sorti en 1967 avec les tous premiers mixes de l'album avant les overdubs.",
    ref: [img0603497817276, img0603497817276B],
  },
  {
    artist: "The Jayhawks",
    title: "Blue Earth",
    format: "LP + 45T",
    description:
      "Réédition du 2ème album des Jayhawks. Inclus un 45T avec 4 titres bonus.",
    ref: [img0603497818921, img0603497818921B],
  },
  {
    artist: "The Jesus & Mary Chain",
    title: "> 45s > 84 > 85<",
    format: "LP - Red and Black Splatter Vinyl",
    description:
      'Réédition vinyle remasterisée de la compilation "> 45s > 84 > 85<" qui regroupe singles et faces B. Inclus "Upside Down", "Psychocandy" et la reprise de Syd Barrett "Vegetable Man".',
    ref: [img5021732531223, img5021732531223B],
  },
  {
    artist: "The Rembrandts",
    title: "L.P. (Opaque Yellow Vinyl)",
    format: "Vinyle jaune",
    description:
      "L'album L.P. des Rembrandts, disponible en double LP pour son 30e anniversaire, inclut leur célèbre chanson thème de la sitcom Friends, ainsi que des titres bonus inédits. Pressage limité sur vinyle jaune pour le Record Store Day.",
    ref: [img0810075114867],
  },
  {
    artist: "The Replacements",
    title: "Tim",
    format: "2LP",
    description:
      "Réédition vinyle de couleur 40ème anniversaire du 4ème album des Replacements. Inclus l'album remasterisé en 2023 + le Ed Stadium Mix sorti à l'origine dans le cadre du coffret de l'édition Let it Bleed. Edition.",
    ref: [img0081227812096, img0081227812096B],
  },
  {
    artist: "Todd Rundgren",
    title: "Initiation",
    format: "2LP - Translucent Light Blue Vinyl",
    description:
      'Réédition de l\'album "Intuition" de Todd Rundgren sorti en 1975. Inclus "A Treatise on Cosmic Fire" un titre instrumental de 36 minutes.',
    ref: [img0603497818969, img0603497818969B],
  },
  {
    artist: "Wallows",
    title: "More - EP",
    format: "LP - Green & White LP",
    description:
      "Nouvel EP. Inclus 7 nouvelles chansons. Disponible en version CD.",
    ref: [img0075678601699, img0075678601699B],
  },
  // {
  //   artist: "Wallows",
  //   title: "More - EP",
  //   format: "CD",
  //   description: "Nouvel EP. Inclus 7 nouvelles chansons.",
  //   ref: [img0075678601453],
  // },
  {
    artist: "Yes",
    title: "Live at the Rainbow, London, England 12/16/1972",
    format: "3LP",
    description:
      'Concert enregistré au Rainbow à Londres le 15 décembre 1972. Inclus les classiques "And You and I", "I’ve Seen All Good People" et "Roundabout".',
    ref: [img0603497819140, img0603497819140B],
  },
];

export default records;
